"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("@material-ui/core/styles");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var _wrapper;

  var breakpoints = _ref.breakpoints;
  return {
    wrapper: (_wrapper = {
      display: 'grid',
      gridGap: '1.75rem',
      gridTemplateColumns: '1fr'
    }, _defineProperty(_wrapper, breakpoints.up('sm'), {
      gridTemplateColumns: '1fr 1fr'
    }), _defineProperty(_wrapper, breakpoints.up('md'), {
      gridTemplateColumns: '1fr 1fr 1fr'
    }), _wrapper)
  };
});
var _default = useStyles;
exports["default"] = _default;